import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { connect } from "react-redux";
import { closePatient } from "store/actions/patient.actions";
import { useTranslation } from "react-i18next";
import { DeleteOptionalTarificationSessionType } from "store/types/tarification.types";
import { Patient } from "model/patient.model";
import { TarificationSessionKey } from "model/tarification-session-key.model";
import { GlobalState } from "store/configure-store";
import { selectUser } from "store/reducers/user-context.reducer";
import {
  selectPatient,
  selectTarificationFinishedResult,
} from "store/reducers/patient.reducer";
import { deleteOptionalTarificationSession } from "store/actions/tarification.actions";
import { User } from "model/user.model";
import Page from "ui/Page";
import { Brand, Form } from "@cc/react-components";
import { TarificationApplicationSession } from "model/tarification.model";
import { AttestationProgress } from "model/attestion.model";

export interface Props
  extends React.HTMLAttributes<HTMLElement>,
    RouteComponentProps {
  inView: boolean;
}

const BackToStartContainer = ({
  inView,
  history,
  user,
  patient,
  tarificationSession,
  tarificationSessionKey,
  attestationProgress,
  deleteOptionalTarificationSession,
  closePatient,
}: StateFromProps & DispatchFromProps & Props) => {
  const [t] = useTranslation();
  useEffect(() => {
    if (inView) {
      if (attestationProgress === AttestationProgress.ERROR_TARIFICATION) {
        deleteOptionalTarificationSession(
          tarificationSession,
          user.id,
          patient.id,
          tarificationSessionKey
        );
      }
      closePatient();
      history.replace("/");
    }
  }, [
    inView,
    history,
    user,
    patient,
    tarificationSession,
    tarificationSessionKey,
    attestationProgress,
    deleteOptionalTarificationSession,
    closePatient,
  ]);

  return (
    <Page.Scrollable>
      <Page.Body>
        <div className="h-100 w-100 d-flex flex-column align-items-center">
          <div className="flex-grow-1" />
          <Brand application="Visit" mobile className="mb-3" />
          <Form className="w-100 mt-3 mb-3">
            <Form.Input type="text" placeholder={t("patientSearch.search")} />
          </Form>
          <div className="flex-grow-1" />
          <p className="text-center text-muted">
            {"1.0." + (process.env.REACT_APP_BUILD_NUMBER || "0")}
          </p>
        </div>
      </Page.Body>
    </Page.Scrollable>
  );
};

interface StateFromProps {
  user: User;
  patient: Patient;
  tarificationSession: TarificationApplicationSession;
  tarificationSessionKey: TarificationSessionKey | undefined;
  attestationProgress: AttestationProgress;
}

interface DispatchFromProps {
  closePatient: () => void;
  deleteOptionalTarificationSession: DeleteOptionalTarificationSessionType;
}

const mapStateToProps = (state: GlobalState) => {
  return {
    user: selectUser(state),
    patient: selectPatient(state),
    tarificationSession: state.tarification.tarificationApplicationSession,
    tarificationSessionKey: state.patientContext.tarificationSession,
    attestationProgress: selectTarificationFinishedResult(state),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    closePatient,
    deleteOptionalTarificationSession,
  })(BackToStartContainer)
);
